export default {
  search: false,
  headerStyle: {
    padding: '14px 40px 14px 25px'
  }
};
